export default "__VITE_ASSET__DQO5ingA__"